function createMainBannerSwipper() {
  new Swiper(".swiperHome", {
    autoplay: { delay: 3e3, disableOnInteraction: !1 },
    loop: !0,
    pagination: {
      el: ".swiper-pagination",
      clickable: !0,
      type: "custom",
      renderCustom: function (e, t, n) {
        var o = "";
        for (i = 1; i < n + 1; i++)
          o =
            i == t
              ? o +
                '<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex=' +
                i +
                ' role="button" aria-label="Go to slide ' +
                i +
                '1"></span>'
              : o +
                '<span class="swiper-pagination-bullet" tabindex=' +
                i +
                ' role="button" aria-label="Go to slide ' +
                i +
                '1"></span>';
        return o;
      },
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  }),
    document
      .querySelector(".swiperHome")
      .addEventListener("mouseover", function () {
        document.querySelector(".swiperHome").swiper.autoplay.stop();
      }),
    document
      .querySelector(".swiperHome")
      .addEventListener("mouseout", function () {
        document.querySelector(".swiperHome").swiper.autoplay.start();
      });
}
function createCountriesSwipper() {
  new Swiper("#navigation-countries .swiper", {
    loop: !0,
    slidesPerView: 1.3,
    spaceBetween: 12,
    navigation: {
      nextEl: "#navigation-countries .swiper-button-next-custom",
      prevEl: "#navigation-countries .swiper-button-prev-custom",
    },
    breakpoints: {
      370: { slidesPerView: 2, spaceBetween: 12 },
      700: { slidesPerView: 3, spaceBetween: 0 },
      820: { slidesPerView: 4, spaceBetween: 0 },
      1300: { slidesPerView: 6, spaceBetween: 5 },
    },
  });
}
function createNavProdSwipper() {
  window.innerWidth < 641 &&
    new Swiper("#navigation-products .swiper", {
      slidesPerView: 1,
      navigation: {
        nextEl: "#navigation-products .swiper-button-next-custom",
        prevEl: "#navigation-products .swiper-button-prev-custom",
      },
    });
}
function createBlogSwipper() {
  window.innerWidth <= 1300 &&
    new Swiper("#blog-section .swiper", {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: !0,
      navigation: {
        nextEl: "#blog-section .swiper-button-next-custom",
        prevEl: "#blog-section .swiper-button-prev-custom",
      },
      breakpoints: {
        548: { slidesPerView: 2, spaceBetween: 10 },
        767: { slidesPerView: 3, spaceBetween: 10 },
      },
    });
}
document.addEventListener("DOMContentLoaded", function () {
  createMainBannerSwipper(),
    createCountriesSwipper(),
    createBlogSwipper(),
    createNavProdSwipper();
});
